import { Link } from 'react-router-dom';
import { tracking } from '../../utils/tracking';
import { svgs } from '../../assets/svgs';


export const RegisterCards = ({ cards }) => {

   return (
      <div className='register-cards'>
         <div className='cards-container'>
            {
               cards.map((card, i) =>
                  <div key={i} className='card'>
                     <section>
                        {card.title && <h4>{card.title}</h4>}
                        {card.content1 && <p>{card.content1}</p>}
                        {card.content2 && <p>{card.content2}</p>}
                     </section>
                     <section>
                        {card.img && <img src={card.img} alt={`${card.title} image`} />}
                        {card.btnLink && <div className="btn-container">
                           <Link className='btn' to={card.btnLink} onClick={() => tracking(card.btnId)}>{card.btnTxt}</Link>
                        </div>}
                     </section>
                  </div>
               )
            }
         </div>
      </div>
   );
};
